
import React from "react";

const ViewStudentModal = ({ student, closeModal }) => {
  console.log("ViewStudentModal props - student:", student); // Debug

  if (!student) return null;

  return (
    <div className="modal fade" id="view_student">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="fw-bold">
              {student.first_name} {student.last_name}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              onClick={closeModal}
              aria-label="Close modal"
            />
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-md-6 mb-3">
                <strong>First Name:</strong> {student.first_name || "N/A"}
              </div>
              <div className="col-md-6 mb-3">
                <strong>Last Name:</strong> {student.last_name || "N/A"}
              </div>
              <div className="col-md-6 mb-3">
                <strong>Email:</strong> {student.email}
              </div>
              <div className="col-md-6 mb-3">
                <strong>Phone:</strong> {student.phone || "N/A"}
              </div>
              <div className="col-md-6 mb-3">
                <strong>Date of Birth:</strong>{" "}
                {student.date_of_birth
                  ? new Date(student.date_of_birth).toLocaleDateString()
                  : "N/A"}
              </div>
              <div className="col-md-6 mb-3">
                <strong>Mother's Name:</strong> {student.mother_name || "N/A"}
              </div>
              <div className="col-md-6 mb-3">
                <strong>Father/Husband Name:</strong> {student.father_husband_name || "N/A"}
              </div>
              <div className="col-md-6 mb-3">
                <strong>Registration Number:</strong> {student.registration_number || "N/A"}
              </div>
              <div className="col-md-6 mb-3">
                <strong>Present Village:</strong> {student.present_village || "N/A"}
              </div>
              <div className="col-md-6 mb-3">
                <strong>Present City:</strong> {student.present_city || "N/A"}
              </div>
              <div className="col-md-6 mb-3">
                <strong>Present District:</strong> {student.present_district || "N/A"}
              </div>
              <div className="col-md-6 mb-3">
                <strong>Present State:</strong> {student.present_state || "N/A"}
              </div>
              <div className="col-md-6 mb-3">
                <strong>Present Pincode:</strong> {student.present_pincode || "N/A"}
              </div>
              {/* <div className="col-md-6 mb-3">
                <strong>Photo:</strong>{" "}
                {student.photo_path ? (
                  <img
                    src={`https://indianairways.net/storage/${student.photo_path}`}
                    alt={`${student.first_name}'s photo`}
                    style={{ width: "100px", height: "auto" }}
                  />
                ) : (
                  "N/A"
                )}
              </div> */}
            </div>

            <h6 className="mt-4">Housekeeping Applications</h6>
            {student.housekeeping_applications.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Application Number</th>
                      <th>Status</th>
                      <th>Apply For</th>
                      <th>Photo</th>
                    </tr>
                  </thead>
                  <tbody>
                    {student.housekeeping_applications.map((app, index) => (
                      <tr key={index}>
                        <td>{app.application_number || "N/A"}</td>
                        <td>{app.status || "N/A"}</td>
                        <td>{app.apply_for || "N/A"}</td>
                        <td>
                          {app.photo_path ? (
                            <img
                              src={`https://indianairways.net/storage/${app.photo_path}`}
                              alt={`Housekeeping application ${app.application_number} photo`}
                              style={{ width: "50px", height: "auto" }}
                            />
                          ) : (
                            "N/A"
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="text-muted">No housekeeping applications.</p>
            )}

            <h6 className="mt-4">CSA Applications</h6>
            {student.csa_applications.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Application Number</th>
                      <th>Status</th>
                      <th>Apply For</th>
                      <th>Photo</th>
                    </tr>
                  </thead>
                  <tbody>
                    {student.csa_applications.map((app, index) => (
                      <tr key={index}>
                        <td>{app.application_number || "N/A"}</td>
                        <td>{app.status || "N/A"}</td>
                        <td>{app.apply_for || "N/A"}</td>
                        <td>
                          {app.photo_path ? (
                            <img
                              src={`https://indianairways.net/storage/${app.photo_path}`}
                              alt={`CSA application ${app.application_number} photo`}
                              style={{ width: "50px", height: "auto" }}
                            />
                          ) : (
                            "N/A"
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="text-muted">No CSA applications.</p>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn bg-gray-100 rounded-pill"
              data-bs-dismiss="modal"
              onClick={closeModal}
              aria-label="Close"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewStudentModal;